import { webStorage, parseLocationSearch } from 'utils'

export default () => ({
  language: webStorage.getItem('language'),
  propertyId: webStorage.getItem('propertyId'),
  ...parseLocationSearch(),
})
